<template>
  <div id="app" class="main-content dashboard">
    <!-- Fancy Loader -->
    <div v-if="!isLoaded" class="fancy-loader-container">
      <div class="fancy-loader"></div>
      <p class="loader-text">Loading...</p>
    </div>

    <!-- Main Content -->
    <div v-else>
      <div class="row">
        <div class="dash-item col-sm-6">
          <router-link slot="item-title" to="/supplier/invoices">
            <div class="dashbox">
              <div class="desc">
                <span class="amount">{{ getTotalDueAmount }}</span>
                <span class="title">
                  {{ $t("dashboard.cards.due_amount") }}
                </span>
              </div>
              <div class="icon">
                <invoice-icon class="card-icon" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="dash-item col-sm-6">
          <router-link slot="item-title" to="/supplier/customers">
            <div class="dashbox">
              <div class="desc">
                <span class="amount">{{ getContacts }}</span>
                <span class="title">
                  {{ $t("dashboard.cards.customers") }}
                </span>
              </div>
              <div class="icon">
                <contact-icon class="card-icon" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="dash-item col-sm-6">
          <router-link slot="item-title" to="/supplier/invoices">
            <div class="dashbox">
              <div class="desc">
                <span class="amount">{{ getInvoices }}</span>
                <span class="title">
                  {{ $t("dashboard.cards.invoices") }}
                </span>
              </div>
              <div class="icon">
                <invoice-icon class="card-icon" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="dash-item col-sm-6">
          <router-link slot="item-title" to="/supplier/purchase-orders">
            <div class="dashbox">
              <div class="desc">
                <span class="amount">{{ getPurchaseOrders }}</span>
                <span class="title">
                  {{ $t("dashboard.cards.purchase_orders") }}
                </span>
              </div>
              <div class="icon">
                <estimate-icon class="card-icon" />
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="card">
        <div class="row">
          <div class="col-lg-12 mt-2 px-4">
            <div class="styled-select">
              <base-select
                v-model="selectedDiv"
                :options="invoiceType"
                :allow-empty="false"
                :show-labels="false"
                :placeholder="$t('Select Invoice Type')"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-2 px-4">
            <div class="card dashboard-card">
              <div class="graph-body">
                <div class="card-body col-md-12 col-lg-12 col-xl-10">
                  <div class="card-header">
                    <h6>
                      <i class="fa fa-line-chart text-primary" />{{
                        $t("dashboard.monthly_chart.title")
                      }}
                    </h6>
                    <div class="year-selector">
                      <base-select
                        v-model="selectedYear"
                        :options="years"
                        :allow-empty="false"
                        :show-labels="false"
                        :placeholder="$t('dashboard.select_year')"
                      />
                    </div>
                  </div>

                  <line-chart
                    :format-money="$utils.formatMoney"
                    :format-graph-money="$utils.formatGraphMoney"
                    :invoices="getChartInvoices"
                    :labels="getChartMonths"
                    :outstanding-invoices="getChartOutstandingInvoices"
                    class=""
                  />
                </div>
                <div class="chart-desc col-md-12 col-lg-12 col-xl-2">
                  <div class="stats">
                    <div class="description">
                      <span class="title">
                        {{ $t("dashboard.chart_info.total_sales") }}
                      </span>
                      <br />
                      <span class="total">
                        <div
                          v-html="
                            $utils.formatMoney(getTotalSales, defaultCurrency)
                          "
                        />
                      </span>
                    </div>
                    <div class="description">
                      <span class="title">
                        {{ $t("dashboard.chart_info.total_outstanding_invoice") }}
                      </span>
                      <br />
                      <span class="total" style="color:#1E88E5;">
                        <div
                          v-html="
                            $utils.formatMoney(
                              getTotalOutstandingInvoices,
                              defaultCurrency
                            )
                          "
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="selectedDiv === 'Invoice' || selectedDiv === 'All'">
          <InvoiceDashboard />
        </div>
        <div v-show="selectedDiv === 'Preapproved Invoice' || selectedDiv === 'All'">
          <PreapprovedInvoiceDashboard />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LineChart from '../../components/chartjs/LineChart'
import BarChart from '../../components/chartjs/BarChart'
import PieChart from '../../components/chartjs/PieChart'
import DollarIcon from '../../components/icon/DollarIcon'
import ContactIcon from '../../components/icon/ContactIcon'
import InvoiceIcon from '../../components/icon/InvoiceIcon'
import EstimateIcon from '../../components/icon/EstimateIcon'
import InvoiceDashboard from './InvoiceDashboard.vue'
import PreapprovedInvoiceDashboard from './PreapprovedInvoiceDashboard.vue'



export default {
  components: {
    PieChart,
    LineChart,
    BarChart,
    DollarIcon,
    ContactIcon,
    InvoiceIcon,
    EstimateIcon,
    InvoiceDashboard,
    PreapprovedInvoiceDashboard
  },
  data () {
    return {
      selectedDiv: 'All',

      preapprovedInvoiceGroupCount: [],

      hoverBgColors: [],
      bgColors: [
        '#334CFF',
        '#E333FF',
        '#33FF71',
        '#F9FF33',
        '#FFB233',
        '#FF3F33'
      ],
      values: [20, 20, 5, 9, 7],
      labels: [
        'Pending',
        'Offered',
        'Financed',
        'Prepaid',
        'Settlement',
        'Rejected'
      ],

      isLoaded: false,
      years: ['This year', 'Previous year'],
      selectedYear: 'This year',
      invoiceType: ['All', 'Invoice', 'Preapproved Invoice'],
      selectedFunder: null,
      updateChart: true,
      financedAmount: 0,
      PieData: [100, 900],
      CreditLimitBgColors: ['#33FF71', '#FF3F33'],
      CreditLimitData: [],
      fundedAmount: 0,
      total_credit_limit: 0
    }
  },
  computed: {
    ...mapGetters('user', {
      user: 'currentUser'
    }),
    ...mapGetters('dashboard', [
      'getFunders',
      'getChartMonths',
      'getChartInvoices',
      'getChartOutstandingInvoices',
      'getChartExpenses',
      'getNetProfits',
      'getReceiptTotals',
      'getContacts',
      'getInvoices',
      'getEstimates',
      'getPurchaseOrders',
      'getTotalDueAmount',
      'getTotalOutstandingInvoices',
      'getTotalSales',
      'getTotalReceipts',
      'getTotalExpenses',
      'getNetProfit',
      'getLoadedData',
      'getDueInvoices',
      'getOfferInvoices',
      'getRecentEstimates',
      'invoiceGroupCount',
      'preapprovedInvoiceGroupCount',
      'funderCreditLimitChart',
      'getRateOfPrePayment'
    ]),
    ...mapGetters('currency', ['defaultCurrency']),
    totalinvoiceGroup () {
      return this.invoiceGroupCount.reduce((acc, item) => acc + item, 0)
    },
    totalpreapprovedinvoiceGroup () {
      return this.preapprovedInvoiceGroupCount.reduce(
        (acc, item) => acc + item,
        0
      )
    }
  },
  created () {
    this.loadData()
  },
watch: {
  selectedYear(val) {
    const isPreviousYear = val === 'Previous year'
    const params = isPreviousYear ? { previous_year: true } : {}
    this.loadData(params)
  },

  selectedFunder(val) {
    if (!val) {
      this.loadData()
      return
    }

    this.updateChart = true
    const params = { funder_company_id: val.company_id }
    this.loadData(params)
  }
},

  methods: {
    ...mapActions('dashboard', ['getChart', 'loadData']),
    ...mapActions('invoice', ['deleteInvoice', 'sendEmail', 'markAsSent']),
    ...mapActions('estimate', [
      'deleteEstimate',
      'markAsAccepted',
      'markAsRejected',
      'convertToInvoice'
    ]),
    ...mapActions('estimate', {
      sendEstimateEmail: 'sendEmail',
      markEstimateAsSent: 'markAsSent'
    }),

    processPreapprovedData (newData) {
      this.preapprovedInvoiceGroupCount = [...newData]
    },

    async loadData(params) {
    try {
    let res = await this.$store.dispatch('dashboard/loadData', params)

    if (res.data.funder === true) {
      this.updateChart = true
    }

    this.financedAmount = res.data.financedAmount
    this.CrditLimitLabels = res.data.credit_limit_data.labels
    this.total_credit_limit = res.data.credit_limit_data.total_credit_limit
    this.CreditLimitData = res.data.credit_limit_data.chart

    if (res.data.preapprovedInvoiceGroupCount) {
      this.preapprovedInvoiceGroupCount = [
        ...res.data.preapprovedInvoiceGroupCount
      ]
    }

      this.isLoaded = true
     } catch (error) {
    console.error('Failed to load dashboard data:', error)
    this.isLoaded = false
     }
  },


    async removeEstimate (id) {
      this.id = id
      window
        .swal({
          title: this.$t('general.are_you_sure'),
          text: this.$tc('estimates.confirm_delete', 1),
          icon: '/assets/icon/trash-solid.svg',
          buttons: true,
          dangerMode: true
        })
        .then(async willDelete => {
          if (willDelete) {
            let res = await this.deleteEstimate(this.id)
            if (res.data.success) {
              window.toastr['success'](
                this.$tc('estimates.deleted_message', 1)
              )
              this.refreshEstTable()
            } else if (res.data.error) {
              window.toastr['error'](res.data.message)
            }
          }
        })
    },

    refreshInvTable () {
      this.$refs.inv_table.refresh()
    },

    refreshEstTable () {
      this.$refs.est_table.refresh()
    },

    async convertInToinvoice (id) {
      window
        .swal({
          title: this.$t('general.are_you_sure'),
          text: this.$t('estimates.confirm_conversion'),
          icon: '/assets/icon/file-alt-solid.svg',
          buttons: true,
          dangerMode: true
        })
        .then(async willDelete => {
          if (willDelete) {
            let res = await this.convertToInvoice(id)
            this.selectAllField = false
            if (res.data) {
              window.toastr['success'](this.$t('estimates.conversion_message'))
              this.$router.push(`invoices/${res.data.invoice.id}/edit`)
            } else if (res.data.error) {
              window.toastr['error'](res.data.message)
            }
          }
        })
    },

    async onMarkAsSent (id) {
      window
        .swal({
          title: this.$t('general.are_you_sure'),
          text: this.$t('estimates.confirm_mark_as_sent'),
          icon: '/assets/icon/check-circle-solid.svg',
          buttons: true,
          dangerMode: true
        })
        .then(async willMarkAsSent => {
          if (willMarkAsSent) {
            const data = {
              id: id
            }
            let response = await this.markEstimateAsSent(data)
            this.refreshEstTable()
            if (response.data) {
              window.toastr['success'](
                this.$tc('estimates.mark_as_sent_successfully')
              )
            }
          }
        })
    },

    async removeInvoice (id) {
      this.id = id
      window
        .swal({
          title: this.$t('general.are_you_sure'),
          text: this.$tc('invoices.confirm_delete'),
          icon: '/assets/icon/trash-solid.svg',
          buttons: true,
          dangerMode: true
        })
        .then(async willDelete => {
          if (willDelete) {
            let res = await this.deleteInvoice(this.id)
            if (res.data.success) {
              window.toastr['success'](this.$tc('invoices.deleted_message'))
              this.refreshInvTable()
            } else if (res.data.error) {
              window.toastr['error'](res.data.message)
            }
          }
        })
    },

    async sendInvoice (row) {
      if (row.attachments.length > 0) {
        swal({
          title: this.$t('general.are_you_sure'),
          text: this.$t('invoices.confirm_send'),
          icon: '/assets/icon/paper-plane-solid.svg',
          buttons: true,
          dangerMode: true
        }).then(async value => {
          console.log(value)
          if (value) {
            const data = {
              invoice_id: row.id
            }
            let response = await this.sendEmail(data)
            this.refreshTable()
            if (response.data.success) {
              window.toastr['success'](
                this.$tc('invoices.send_invoice_successfully')
              )
              if (row.pre_pay === 1) {
                this.showPrePaymentRequestPopup(row.id)
              }
              return true
            }
            if (response.data.error === 'user_email_does_not_exist') {
              window.toastr['error'](
                this.$tc('invoices.user_email_does_not_exist')
              )
              return false
            }
            window.toastr['error'](this.$tc('invoices.something_went_wrong'))
          }
        })
      } else {
        swal({
          title: this.$t('general.attach_documents'),
          text: this.$t('invoices.without_attachments_you_cant_sent'),
          icon: '/assets/icon/file-alt-solid.svg',
          buttons: true,
          dangerMode: true,
          buttons: {
            buttonOne: {
              text: 'Continue Anyway',
              value: 'continue_anyway',
              visible: true,
              className: 'swal-button--cancel',
              closeModal: true
            },
            buttonTwo: {
              text: 'Go to Attachments',
              value: 'go_to_attachments',
              visible: true,
              className: 'swal-button--danger',
              closeModal: true
            }
          }
        }).then(async goToAttachment => {
          if (goToAttachment === 'go_to_attachments') {
            this.$router.push(`/supplier/invoices/${row.id}/attachment`)
          } else if (goToAttachment === 'continue_anyway') {
            const data = {
              invoice_id: row.id
            }
            let response = await this.sendEmail(data)
            this.refreshInvTable()
            if (response.data.success) {
              window.toastr['success'](
                this.$tc('invoices.send_invoice_successfully')
              )
              if (row.pre_pay == 1) {
                this.showPrePaymentRequestPopup(row.id)
              }
              return true
            }
            if (response.data.error === 'user_email_does_not_exist') {
              window.toastr['error'](
                this.$tc('invoices.user_email_does_not_exist')
              )
              return false
            }
            window.toastr['error'](this.$tc('invoices.something_went_wrong'))
          }
        })
      }
    },
    async showPrePaymentRequestPopup (id) {
      swal({
        title: this.$t('invoices.request_apply_for_PrePayment'),
        text: this.$t('invoices.do_you_want_to_apply_for_prepayment_request'),
        icon: '/assets/icon/check-circle-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async value => {
        if (value) {
          this.prepaymentRequest(id)
        } else {
          this.refreshInvTable()
        }
      })
    },
    async prepaymentRequest (id) {
      this.$router.push(`/supplier/prepayments/${id}/request`)
    },

    async sentInvoice (id) {
      window
        .swal({
          title: this.$t('general.are_you_sure'),
          text: this.$t('invoices.invoice_mark_as_sent'),
          icon: '/assets/icon/check-circle-solid.svg',
          buttons: true,
          dangerMode: true
        })
        .then(async willMarkAsSend => {
          if (willMarkAsSend) {
            const data = {
              id: id
            }
            let response = await this.markAsSent(data)
            this.refreshInvTable()
            if (response.data) {
              window.toastr['success'](
                this.$tc('invoices.mark_as_sent_successfully')
              )
            }
          }
        })
    },

    async onMarkAsAccepted (id) {
      window
        .swal({
          title: this.$t('general.are_you_sure'),
          text: this.$t('estimates.confirm_mark_as_accepted'),
          icon: '/assets/icon/check-circle-solid.svg',
          buttons: true,
          dangerMode: true
        })
        .then(async markedAsRejected => {
          if (markedAsRejected) {
            const data = {
              id: id
            }
            let response = await this.markAsAccepted(data)
            this.refreshEstTable()
            if (response.data) {
              this.refreshEstTable()
              window.toastr['success'](
                this.$tc('estimates.marked_as_accepted_message')
              )
            }
          }
        })
    },

    async onMarkAsRejected (id) {
      window
        .swal({
          title: this.$t('general.are_you_sure'),
          text: this.$t('estimates.confirm_mark_as_rejected'),
          icon: '/assets/icon/times-circle-solid.svg',
          buttons: true,
          dangerMode: true
        })
        .then(async markedAsRejected => {
          if (markedAsRejected) {
            const data = {
              id: id
            }
            let response = await this.markAsRejected(data)
            this.refreshEstTable()
            if (response.data) {
              this.refreshEstTable()
              window.toastr['success'](
                this.$tc('estimates.marked_as_rejected_message')
              )
            }
          }
        })
    },
    async viewOffer (id) {
      this.$router.push(`/supplier/prepayments/${id}/offer`)
    },
    nomailAmount (row) {
      let subTotal = row.sub_total
      let nomailAmount = 0
      let taxes = null
      if (row.taxes) {
        taxes = row.taxes.filter(function (obj) {
          return obj.operator !== 'Subtract'
        })
        if (taxes.length > 0) {
          nomailAmount =
            subTotal +
            taxes
              .map(o => o.amount)
              .reduce((a, c) => {
                return a + c
              })
        } else {
          nomailAmount = row.sub_total
        }
      }
      return nomailAmount
    },
    async sendEstimate (id) {
      window
        .swal({
          title: this.$t('general.are_you_sure'),
          text: this.$t('estimates.confirm_send_estimate'),
          icon: '/assets/icon/paper-plane-solid.svg',
          buttons: true,
          dangerMode: true
        })
        .then(async willSendEstimate => {
          if (willSendEstimate) {
            const data = {
              id: id
            }
            let response = await this.sendEstimateEmail(data)
            this.refreshEstTable()
            if (response.data.success) {
              window.toastr['success'](
                this.$tc('estimates.send_estimate_successfully')
              )
              return true
            }
            if (response.data.error === 'user_email_does_not_exist') {
              window.toastr['error'](
                this.$tc('estimates.user_email_does_not_exist')
              )
              return true
            }
            window.toastr['error'](this.$tc('estimates.something_went_wrong'))
          }
        })
    }
  }
}
</script>

<style scoped>
.styled-select {
  margin-bottom: 10px;
  margin-top: 10px;
}

.fancy-loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
}

.fancy-loader {
  border: 8px solid #f3f3f3;
  border-top: 5px solid #3d4d5b;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

.loader-text {
  font-size: 1.2rem;
  color: #293641;
  font-weight: bold;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
